appSocial.component('leaderCard', {
    templateUrl: 'widgets/leaders-feed/components/leader-card/LeaderCardComponent.html',
    bindings: {
        trader: '<',
        onSelect: '&',
        // possible values: '' - default, 'compare' - compare mode
        /**
         * @type {CardMode}
         */
        mode: '<'
    },
    controller: class LeaderCardComponent {
        constructor($state,
                    $scope,
                    $timeout,
                    SocialLocaleService,
                    SocialUtils,
                    SocialActionService,
                    SocialTypes,
                    LeadersCompareService) {

            this.translation = SocialLocaleService.translation;

            /**
             * @type {SocialUtils}
             */
            this.utils = SocialUtils;

            /**
             * @type {SocialActionService}
             */
            this.actionService = SocialActionService;

            /**
             * @type {SocialTypes}
             */
            this.types = SocialTypes;

            /**
             * @type {LeadersCompareService}
             */
            this.compareService = LeadersCompareService;

            this.isSwipe = false;
            this.swipeOffset = 0;
            this.buttonOffset = 0;
            this.swipeDirection = 'right';

            $scope.$on('leadersCompare.disableSelection', () => {
                this.compareService.remove(this.trader);
                // reset swipe position
                this.swipeOffset = 0;
                this.buttonOffset = 0;
            })

            this.$timeout = $timeout;
            this.isSwipeable = true;

            // $scope.$on('scroll.start', () => {
            //     this.isSwipeable = false;
            // });
            //
            // $scope.$on('scroll.stop', () => {
            //     this.isSwipeable = true;
            // });
        }

        $onInit() {
            if (this.isComparing()) {
                this.setCompared();
            }
            if (this.mode === 'compare') {
                this.isSwipe = false;
            }
        }

        $onChanges(changes) {
            //console.log('trader changes', this.trader)
        }

        $onDestroy() {
        }

        toggleCard(trader) {
            this.onSelect({trader})
            trader.expanded = !trader.expanded;
        }

        callAction(trader) {
            const {CopyAction} = this.types;
            if (trader.isFollowed) {
                return this.utils.navigate('root.app.socialFunds', {id: trader.id, action: CopyAction.AddFunds})
            }

            this.actionService.stateCheck({trader, action: CopyAction.StartCopy})
        }

        callCompareAction() {
            if (this.isComparing()) {
                this.compareService.remove(this.trader);
                return;
            }

            if (!this.compareService.isComparing) {
                this.compareService.enableSelection();
            }

            if (!this.compareService.limitReached) {
                this.compareService.add(this.trader);
            }
        }

        startSwipe() {
            if (this.mode === 'compare') {
                return;
            }

            this.isSwipe = true;
        }

        stopSwipe() {
            // skip action if we are started to swipe
            if (!this.isSwipe) {
                return;
            }

            // skip action if it's not permitted to swipe
            if (!this.isSwipeable) {
                return;
            }

            if (this.swipeOffset <= 70) {
                this.swipeOffset = 0;
                this.buttonOffset = 0;
            } else {
                this.swipeOffset = 73;
                this.buttonOffset = 73;
            }

            this.isSwipe = false;
            this.toggleCompare();
        }

        onDrag(e) {
            this.swipeOffset = this.buttonOffset + e.gesture.deltaX;
        }

        toggleCompare() {
            // open swipe -> add to compare
            if (this.swipeOffset > 0) {
                if (this.isComparing()) {
                    return;
                }

                if (this.compareService.limitReached) {
                    // reset swipe position
                    this.swipeOffset = 0;
                    this.buttonOffset = 0;
                    return;
                }

                if (!this.compareService.isComparing) {
                    this.compareService.enableSelection();
                }

                //add to compare
                this.compareService.add(this.trader);
            } else {
                if (!this.isComparing()) {
                    return;
                }

                // remove from compare
                this.compareService.remove(this.trader);

                if (!this.compareService.traders.length) {
                    this.compareService.disableSelection();
                }
            }
        }

        setCompared() {
            this.swipeOffset = 73;
            this.buttonOffset = 73;
        }

        isComparing() {
            return this.compareService.isTraderComparing(this.trader)
        }

        removeFromCompare() {
            this.compareService.remove(this.trader);
            // reset swipe position
            this.swipeOffset = 0;
            this.buttonOffset = 0;

            if (!this.compareService.traders.length) {
                this.compareService.disableSelection();
            }
        }

    }
});
